import { render, staticRenderFns } from "./DigitalSignatures.vue?vue&type=template&id=34f159a2&scoped=true&"
import script from "./DigitalSignatures.vue?vue&type=script&lang=js&"
export * from "./DigitalSignatures.vue?vue&type=script&lang=js&"
import style0 from "./DigitalSignatures.vue?vue&type=style&index=0&id=34f159a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f159a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f159a2')) {
      api.createRecord('34f159a2', component.options)
    } else {
      api.reload('34f159a2', component.options)
    }
    module.hot.accept("./DigitalSignatures.vue?vue&type=template&id=34f159a2&scoped=true&", function () {
      api.rerender('34f159a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/verificarQrAprobaciones/vistas/DigitalSignatures.vue"
export default component.exports